import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

const IntroPage = ({
  shouldShowYouAreAllSet,
  onStart
}) => {
  const classes = useStyles()

  // PENG-3063: User has completed the new LPQ
  if (shouldShowYouAreAllSet) {
    return (
      <Box className={classes.content} data-test='intro-page'>
        <Box className={classes.introPageContent}>
          <Typography
            id='lpq-dialog-title'
            className={classes.introPageTitle}
            data-test='intro-page-title'
            component='h2'
          >
            You&apos;re all set!
          </Typography>
          <Typography
            id='lpq-dialog-description'
            className={classes.introPageBody}
            data-test='intro-page-body'
          >
            You&apos;ve already shared your learning preferences with us. If things have changed or you&apos;d like to refine your answers, feel free to update them.
          </Typography>
          <Button
            className={classes.introPageButton}
            onClick={onStart}
            variant='contained'
            data-test='intro-page-cta'
            aria-label='Update questionnaire'
          >
            Update Questionnaire
          </Button>
        </Box>
      </Box>
    )
  }

  // PENG-3062: User has completed old LPQ but not new one
  return (
    <Box className={classes.content} data-test='intro-page'>
      <Box className={classes.introPageContent}>
        <Typography
          id='lpq-dialog-title'
          className={classes.introPageTitle}
          data-test='intro-page-title'
          component='h2'
        >
          Help us make your learning experience even better!
        </Typography>
        <Typography
          id='lpq-dialog-description'
          className={classes.introPageBody}
          data-test='intro-page-body'
        >
          We&apos;ve got a short <strong>Learning Performance Questionnaire</strong> that takes about <strong>2 minutes</strong> to complete. Your answers will help us shape upcoming personalisation updates and make your future experience more tailored to your goals.
        </Typography>
        <Button
          className={classes.introPageButton}
          onClick={onStart}
          variant='contained'
          data-test='intro-page-cta'
          aria-label='Start questionnaire'
        >
          Start Questionnaire
        </Button>
      </Box>
    </Box>
  )
}

export default IntroPage
